import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Paper} from "@mui/material";
import Header from "./Header";
import { API } from "../conf";
import { Context } from "../App";
import success_gif from '../asset/pictures/Successfully Done.gif'
import { useNavigate } from "react-router-dom";

export default function Cloture() {
    const navigate = useNavigate()
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"]
    const [loading, setLoad] = useState(true)
    const [result, setResult] = useState()
    const [uncloture_months, setUncloture_months] = useState([])
    const [month, setMonth] = useState('')
    const [dispo_dons, setDispo_dons] = useState([])
    const [dispo_vers, setDispo_vers] = useState([])
    const [dispo_depenses, setDispo_depenses] = useState([])
    const [dons, setDons] = useState([])
    const [versements, setVersements] = useState([])
    const [depenses, setDepenses] = useState([])

    const eglise = useMemo(()=>{
        if (organisation && !organisation.isFederation && !organisation.isUnion) {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function handleSubmit() {
        setLoad(true)

        function set_cloture(route, items) {return new Promise((resolve, reject) => {
            fetch(API.concat(route), {
                method:'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                body: JSON.stringify(items)
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    resolve(response.status === 200)
                }
            })  
        })}

        set_cloture('/cloture/dons', dons.map(don=> don._id))
        .then(dons_iscloture =>set_cloture('/cloture/depenses', depenses.map(depense=> depense._id))
        .then(depenses_iscloture =>set_cloture('/cloture/versements', versements.map(vers=> vers._id))
        .then(vers_iscloture=> {
            if (dons_iscloture && depenses_iscloture && vers_iscloture) {
                fetch(API.concat(`/user/cloture/${eglise.number}`), {
                    method:'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        periode: months[month],
                        dons: dons.length,
                        versements: versements.length,
                        depenses: depenses.length,
                        eglise: `${eglise.nom} (${eglise.commune})`
                    })
                }).then(async response => {
                    const token = response.headers.get('x-auth-token')
                    if(response.status === 401) {
                        sessionStorage.clear()
                        updateConnect(false)
                    }else {
                        if (token && token !== sessionStorage.getItem('token') && token !== '') {
                            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                        }
                        setResult(<img src={success_gif} alt="succès" loading="eager" width={500} height={500}/>)
                        setTimeout(() => {
                            navigate("/")
                        }, 2500);
                    }
                })
            }else setLoad(false)
        })))        
    }

    function reset() {
        setUncloture_months([])
        setMonth('')
        setDispo_dons([])
        setDispo_vers([])
        setDispo_depenses([])
        setDons([])
        setVersements([])
        setDepenses([])
    }

    useEffect(()=>{
        function get_uncloture(categorie) {return new Promise((resolve, reject) => {
            fetch(API.concat(`/${categorie}/by/${JSON.stringify({eglise: eglise.number, is_cloture: false})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        resolve(json)
                    }
                }
            })
        })}

        if(eglise?.number) {
            setLoad(true)
            get_uncloture('dons').then(ddons =>{
                setDispo_dons(ddons); 
                get_uncloture('versements').then(verses => {
                    const vers = verses.map(v=>{return({...v, date:v.dateDons})})
                    setDispo_vers(vers)
                    get_uncloture('depenses').then(deps=>{
                        setDispo_depenses(deps)
                        //gerer versements mensuel
                        const dmonths = Array.from(new Set(ddons.concat(vers.concat(deps)).map(item => {
                            if (months.includes(item.date)) {
                                return months.indexOf(item.date)
                            } else {
                                return new Date(item.date).getMonth()
                            }
                        })))
                        setUncloture_months(dmonths);
                        setLoad(false)
                    })
                })
            })
        }
    }, [eglise])

    useEffect(()=>{
        if (organisation&&organisation.isFederation) {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{isFederation: false, isUnion: false})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[]) 
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Clôture</Typography>
            {organisation&&organisation.isFederation&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            {eglise&&<Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <TextField
                id="outlined-select-currency"
                select
                sx={{minWidth:'300px', marginBottom:'25px'}}
                required
                label="Mois a clôturer"
                value={month}
                onChange={(e)=> {
                    setMonth(Number(e.target.value))
                    setDons(dispo_dons.filter(don=> new Date(don.date).getMonth()===Number(e.target.value)))
                    //gerer versement mensuel
                    setVersements(dispo_vers.filter(vers=> (months.includes(vers.date) ? months.indexOf(vers.date) : new Date(vers.date).getMonth())===Number(e.target.value)))
                    setDepenses(dispo_depenses.filter(depenses=> new Date(depenses.date).getMonth()===Number(e.target.value)))
                }}
                >
                {loading ? <CircularProgress color="inherit" />
                :uncloture_months.map((month, index) => (
                    <MenuItem key={index} value={month}>
                        <Typography sx={{}}>{months[month]}</Typography> 
                    </MenuItem>
                ))}
                </TextField>
                
                {month !=='' && <div style={{display:'flex', justifyContent:'center'}}><Paper sx={{ height:'100%', paddingX:'25px', paddingY:'30px'}}>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{dons.length}</span> don{dons.length>1 && 's'} d'une recette local totale de 
                    <span style={{fontWeight:'bold'}}> {(dons.reduce((accumulator, currentValue) => {
                            const toadd = currentValue.offrande_spe_eglise.reduce((off_accumulator, off_currentValue)=>{return off_accumulator + off_currentValue.montant}, 0)
                            return accumulator + currentValue.offrande_globale*0.6 + (toadd?? 0)}, 0)).toFixed(2)}€</span>
                    </Typography>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{versements.length}</span> versement{versements.length>1 && 's'}</Typography>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{depenses.length}</span> dépense{depenses.length>1 && 's'} d'un total de
                        <span style={{fontWeight:'bold'}}> {(depenses.reduce((accumulator, currentValue) => {return accumulator + currentValue.montant}, 0)).toFixed(2)}€</span>
                    </Typography>
                </Paper></div>}
            </Box>}

            {versements.some(verse=>verse.is_error)&&<Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                Vous avez un ou plusieurs versements en erreur.<br/>Veuillez contacter votre Administrateur.
            </Typography>}
            {new Date().getMonth() === month ? <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                Vous ne pouvez pas clôturer un mois en cours.
            </Typography>
            :month!=="" && dons.some(don=> !don.is_verse && new Date(don.date).getMonth()===month) && 
            <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                <span style={{fontWeight:'bold'}}>Attention!</span><br/>Il vous reste des dons à verser ou des versements en attente de validation pour le mois de {months[month]}.<br/> Veuillez régulariser votre situation afin de clôturer le mois.
            </Typography>}
            {month !== '' && <Button 
                variant="contained" 
                sx={{ alignSelf:'flex-end', marginRight:'30px', marginTop:'20px' }}
                disabled={month===""|| dons.some(don=> !don.is_verse && new Date(don.date).getMonth()===month) || new Date().getMonth() === month || versements.some(verse=>verse.is_error) }
                onClick={handleSubmit}>Cloturer le mois</Button>
            }

            <Backdrop open={loading}>{result??<CircularProgress color="inherit" />}</Backdrop>
        </div>
    )
}